import React, {Fragment} from 'react';
import {
    useParams
} from "react-router-dom";
import Grid from '@mui/material/Grid';

import MainAppBar from '../../containers/app_bars/main_app_bar';
import BasicCard from '../../containers/cards/basic_card';

import CreateOrder from './create_order';
import Orders from './orders';
import OrdersHistory from './orders_history';
import OrdersHistoryGroupDate from './orders_history/group_date';

import Payments from './payments';
import Departures from './departures';
import Products from './products';
import Clients from './clients';
import Prices from './prices';
import Colors from './colors';
import Sellers from './sellers';
import PocketBalance from './pocket_balance';
import OrdersBox from './orders_box';
import Profile from './profile';
import Users from './users';
import SellerOrders from './seller_orders';
import SellerPocketBalance from './seller_pocket_balance';
import SellerPayments from './seller_payments';
import SellerDepartures from './seller_departures';
import SellerClientOrders from './seller_client_orders';

import MaxMinPrices from './max_min_prices';
import CrudesBox from './crude';
import Dry_cleanerBox from './dry_cleaner';
import ValidationBox from './validation';
import RolledUpBox from './rolled_up';
import DespatchBox from './despatch';
import MarkedBox from './marked';
import HistoryBox from './history';
import ReviewBox from './review';
import RemissionBox from './remission';
import InvoiceBox from './invoice';
import OrdersHistoryGroupClient from './orders_history/group_client/index';
import ClientOrders from './orders_history/info_order/client_order';
import Ean from './ean';
import OrdersHistoryGroupOrder from './orders_history/group_order';
import OrdersBoxInm from './order_box_inm';
import RemissionFact from './remission_fact';
import WeavingBox from './weaving';
import GeneralClientOrders from './orders_history/info_order_client_general/general_client_orders';
import GeneralClientInfoGroup from './orders_history/info_order_client_general/index';
import GeneralClientInfo from './orders_history/info_order_client_general/general_client_info';
import LiveOrdersClient from './orders_history/info_order_client_general/live_orders_client';
import AllOrdersClient from './orders_history/info_order_client_general/all_orders_client';
import DeparturesClient from './orders_history/info_order_client_general/departures_client';
import DeparturesHistory from './orders_history/departures_history';
import RemissionList from './remission_list';
import GeneralHistoryBox from './general_history';


import DeparturesClientDate from './orders_history/departures_history/departures_client';
import GeneralView from './general_view';

const MODULES = {
    "create-order": <CreateOrder />,
    "orders": <Orders />,
    "orders-history": <OrdersHistoryGroupOrder/>,
    "orders-history-copy": <OrdersHistory />,
    "orders-history-group-date": <OrdersHistoryGroupDate />,
    "orders-history-group-client": <OrdersHistoryGroupClient/>,
    "departures": <Departures />,
    "products": <Products />,
    "clients": <Clients />,
    "prices": <Prices />,
    "colors": <Colors />,
    "sellers": <Sellers />,
    "pocket-balance": <PocketBalance />,
    "orders-box": <OrdersBox />,
    "orders-box-inm": <OrdersBoxInm />,
    "payments": <Payments />,
    "profile": <Profile />,
    "users": <Users />,
    "seller-orders": <SellerOrders />,
    "seller-pocket-balance": <SellerPocketBalance />,
    "seller-payments": <SellerPayments />,
    "seller-departures": <SellerDepartures />,
    "seller-client-orders": <SellerClientOrders />,
    "prices-view": <MaxMinPrices />,
    "dry_cleaner": <Dry_cleanerBox/>,
    "crude": <CrudesBox/>,
    "validation" : <ValidationBox/>,
    "rolled_up" : <RolledUpBox/>,
    "despatch" : <DespatchBox/>,
    "marked" : <MarkedBox/>,
    "history" : <HistoryBox/>,
    "review" : <ReviewBox/>,
    "remission" : <RemissionBox/>,
    "invoice" : <InvoiceBox/>,
    "client-orders" : <ClientOrders/>,
    "ean" : <Ean/>,
    "remission-fact": <RemissionFact/>,
    "weaving" : <WeavingBox/>,
    "general-client-info-group" : <GeneralClientInfoGroup/>,
    "general-client-info" : <GeneralClientInfo/>,
    "general-client-orders" : <GeneralClientOrders/>,
    "ean" : <Ean/>,
    "remission-fact": <RemissionFact/>,
    "general-client-info-live": <LiveOrdersClient/>,
    "general-client-info-all": <AllOrdersClient/>,
    "general-client-info-departures": <DeparturesClient/>,
    "departures-history": <DeparturesHistory />,
    "remission-list": <RemissionList />,
    "general-history": <GeneralHistoryBox/>,
    "despatch-client-date": <DeparturesClientDate />,
    "general-view": <GeneralView />,
}

const AppModules = () => {
    let { module } = useParams();
    return (
        <Fragment>
            <MainAppBar />
            <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
                        <BasicCard
                            width={'99%'}
                            title={''}
                            content={
                                renderModule(module)
                            }
                            buttons={
                                <></>
                            }
                        />
                    </div>
                </Grid>
            </Grid>
        </Fragment>
    );
}

const renderModule = (module) => {
    if(module in MODULES){
        return(MODULES[module]);
    } else {
        return <NotFound />
    }
}

function NotFound() {
    return(
      <>Not found</>
    );
  }
  
export default AppModules;
  